<!--The content below is only a placeholder and can be replaced.-->
@if ((hideHeader$ | async) === false) {
<ddd-common-header [loggedUser]="user$ | async"></ddd-common-header>
}
<router-outlet></router-outlet>
@if ((hideFooter$ | async) === false) {
<ddd-common-footer class="footer-container"></ddd-common-footer>
} @if (!isUserPresent) {
<ddd-loading-screen></ddd-loading-screen>
}

<ng-template #updatedUserInfoDialog>
  <ddd-profile [updateUserInfoDialog]="true"></ddd-profile>
</ng-template>
